import { useEffect, useMemo, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './queryClient';
import { setOnUnauthorized } from './unauthorized';

type Props = {
  children: ReactNode;
  onUnauthorized?: () => void;
};

export function QueryProvider({ children, onUnauthorized }: Props) {
  const client = useMemo(() => createQueryClient(), []);

  useEffect(() => {
    setOnUnauthorized(() => {
      client.clear();
      if (onUnauthorized) {
        onUnauthorized();
      } else if (typeof window !== 'undefined') {
        window.location.assign('/login');
      }
    });
    return () => setOnUnauthorized(null);
  }, [client, onUnauthorized]);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
